import React from 'react';
import { Box, Heading, Link, Text } from '@marvelapp/ui';
export default function EmptyState(_a) {
    var canDelete = _a.canDelete, canEditProjects = _a.canEditProjects, onDeleteSection = _a.onDeleteSection;
    return (React.createElement(Box, { alignItems: "center", border: "1px dashed", borderColor: "smoke", borderRadius: 4, display: "flex", flex: 1, justifyContent: "center", mt: 4, position: "relative", px: 4, py: 6 },
        React.createElement(Box, { maxWidth: 380, textAlign: "center" },
            React.createElement(Heading, { fontSize: 17, mb: 2 }, "This section is empty"),
            canEditProjects && canDelete && (React.createElement(Text, null,
                "Drag any image into this area to organise your project",
                ' ',
                canDelete && (React.createElement(React.Fragment, null,
                    "or",
                    ' ',
                    React.createElement(Link, { color: "marvelDark", hoverColor: "marvel", onClick: onDeleteSection }, "delete this section"),
                    ' ',
                    "altogether")))))));
}
